export const menuItems = [
    {
        name: 'About',
        active: 'About',
    },
    {
        name: 'Education',
        active: 'Education'
    },
    {
        name: 'Work Experience',
        active: 'Work Experience'
    },
    {
        name: 'Publication',
        active: 'Publication'
    }
];


// WEBPACK FOOTER //
// ./src/Infos/header.js